var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-value text-value__container no-underline",class:{
    'text-value_danger': _vm.isValueDanger,
  }},[_c('span',{staticClass:"text-value__placeholder text-value__label"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',[_vm._v(_vm._s(_vm.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }